import React from "react";
import App from "./../app.jsx";
import { Navigate } from "react-router-dom";

import Error from "./../pages/error/error.js";
import Login from "../pages/Login.jsx";
import Register from "../pages/Register.jsx";
import ForgotPassword from "../pages/ForgotPassword.jsx";
import SendActivateMail from "../pages/SendActivateMail.jsx";
import ChangePassword from "../pages/ChangePassword.jsx";
import MyAccount from "../pages/MyAccount/MyAccount.jsx";
import Support from "../pages/Support/Support.jsx";
import Mycontacts from "../pages/Mycontacts/Mycontacts.jsx";
import PurchaseHistory from "../pages/Mycontacts/PurchaseHistory.jsx";
import FindInmates from "../pages/FindInmates/FindInmates.jsx";
import FindInmatesTable from "../pages/FindInmates/FindInmatesTable.jsx";
import WriteMessage from "../pages/WriteMessage/WriteMessage.jsx";
import PurchaseCredits from "../pages/PurchaseCredits/PurchaseCredits.jsx";
import PurchaseCreditsPayments from "../pages/PurchaseCredits/PurchaseCreditsPayments.jsx";
import StripeElementsWrapper from "../pages/PurchaseCredits/StripeElementsWrapper.jsx";
import PaymentReceipt from "../pages/PurchaseCredits/PaymentReceipt.jsx";
import Draft from "../pages/Draft/Draft.jsx";
import Inbox from "../pages/Inbox/Inbox.jsx";
import Messenger from "../pages/Inbox/Messenger.jsx";
import SendPhotos from "../pages/SendPhotos/SendPhotos.jsx";
import Profiles from "../pages/SendPhotos/Profiles.jsx";
import SendEcards from "../pages/SendEcards/SendEcards.jsx";
import EcardViewer from "../pages/SendEcards/EcardViewer.jsx";
import Archived from "../pages/Archived/Archived.jsx";
import ArchivedMessagesTable from "../pages/Archived/ArchivedResults.jsx";
import MaintenancePage from "../pages/MaintenancePage.jsx";
import Termsofservice from "../components/common/Termsofservice.jsx";
import PrivacyPolicy from "../components/common/PrivacyPolicy.jsx";
import EcardGallery from "../pages/E-card/Ecard_Gallary.jsx";
import SendECard from "../pages/E-card/SendEcard.jsx";
import PublicRoute from "../_helpers/PublicRoute.js";
import AuthenticateRouter from "../_helpers/AuthenticateRouter.js";
import ErrorPage from "../pages/ErrorPage.jsx";
import VideoCall from "../pages/VideoCall/VideoCall.jsx";

const AppRoute = [
  {
    path: "*",
    element: <AuthenticateRouter><App /> </AuthenticateRouter>,
    children: [
      {
        path: "",
        element: <Navigate to="public/Login" />,
      },
      {
        path: "public/Login",
        element: <Login />,
      },
      {
        path: "public/MyAccount",
        element: <MyAccount />,
      },
     {
        path: "public/VideoCall",
        element: <VideoCall />,
      },
      {
        path: "public/Support",
        element: <Support />,
      },
      {
        path: "public/Mycontacts",
        element: <Mycontacts />,
      },
      {
        path: "public/PurchaseHistory",
        element: <PurchaseHistory />,
      },
      {
        path: "public/SentPhotos",
        element: <SendPhotos />,
      },
      {
        path: "public/SentE-Cards",
        element: <SendEcards />,
      },
      {
        path: "public/E-CardViewer",
        element: <EcardViewer />,
      },
      {
        path: "public/Profile",
        element: <Profiles />,
      },
      {
        path: "public/FindInmates",
        element: <FindInmates />,
      },
      {
        path: "public/FindInmatesTables",
        element: <FindInmatesTable />,
      },
      {
        path: "public/WriteMessage",
        element: <WriteMessage />,
      },
      {
        path: "public/PurchaseCredits",
        element: <PurchaseCredits />,
      },
      {
        path: "public/PurchaseCreditsPayments",
        element: <PurchaseCreditsPayments />,
      },
      {
        path: "StripeElementsWrapper",
        element: <StripeElementsWrapper />,
      },
      {
        path: "StripeElementsWrapper/public/PaymentReceipt",
        element: <PaymentReceipt />,
      },
      {
        path: "public/Draft",
        element: <Draft />,
      },
      {
        path: "public/Inbox",
        element: <Inbox />,
      },
      {
        path: "public/Messenger",
        element: <Messenger />,
      },
      {
        path: "public/Archived",
        element: <Archived />,
      },
      {
        path: "public/ArchivedMessagesTable",
        element: <ArchivedMessagesTable />,
      },
      {
        path: "public/EcardGallary",
        element: <EcardGallery />,
      },
      {
        path: "public/SendE-Card",
        element: <SendECard />,
      },
      {
        path: "*",
        element: <Error />, // Nested catch-all for unknown public routes
      },
    ],
  },
  {
    path: "public/Login",
    element: <PublicRoute><Login /></PublicRoute>,
  },
  {
    path: "public/ChangePassword",
    element: <PublicRoute><ChangePassword /></PublicRoute>,
  },

  {
    path: "public/Register",
    element: <PublicRoute><Register /></PublicRoute>,
  },
  {
    path: "public/ForgotPassword",
    element: <PublicRoute><ForgotPassword /></PublicRoute>,
  },
  {
    path: "public/SendActivateMail",
    element: <PublicRoute><SendActivateMail /></PublicRoute>,
  },
  {
    path: "/termsofservice",
    element: <Termsofservice />,
  },
  {
    path: "/privacyPolicy",
    element: <PrivacyPolicy />,
  },
  {
    path: "public/Maintenance",
    element: <MaintenancePage />,
  },
  {
    path: "public/Error",
    element: <ErrorPage />
  },
  {
    path: "*",
    element: <Error />, // Top-level catch-all as a final fallback
  },
];

export default AppRoute;
